import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRfi = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 17,
	viewBox: "0 0 15 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.28474 7.92259C8.7181 8.4184 8.40376 9.08715 8.40376 9.80466V9.93895C8.40376 10.0583 8.50112 10.1557 8.62049 10.1557H9.46867C9.58804 10.1557 9.6854 10.0583 9.6854 9.93895V9.80466C9.6854 9.07931 10.3998 8.4664 11.3064 8.4664C12.213 8.4664 12.9274 9.07931 12.9274 9.80466C12.9274 10.3165 12.5644 10.7961 11.9845 11.0189C11.5956 11.1675 11.2654 11.428 11.0289 11.769C10.7883 12.1179 10.6638 12.536 10.6638 12.9588V13.3387C10.6638 13.4581 10.7611 13.5555 10.8805 13.5555H11.7287C11.8481 13.5555 11.9454 13.4581 11.9454 13.3387V12.9378C11.9463 12.7815 11.9942 12.629 12.083 12.5004C12.1718 12.3716 12.2973 12.2727 12.4432 12.2163C13.5112 11.8054 14.2071 10.8609 14.2072 9.80485C14.2091 9.08722 13.8947 8.41844 13.3281 7.92264C12.7834 7.44513 12.0657 7.18476 11.3064 7.18476C10.547 7.18476 9.82929 7.44702 9.28474 7.92259Z",
			fill: "#878A8F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.5242 15.3178C10.5242 15.5252 10.6066 15.7242 10.7533 15.8709C10.9 16.0176 11.0989 16.1 11.3064 16.1C11.5138 16.1 11.7128 16.0176 11.8595 15.8709C12.0062 15.7242 12.0886 15.5252 12.0886 15.3178C12.0886 15.1103 12.0062 14.9114 11.8595 14.7647C11.7128 14.618 11.5138 14.5356 11.3064 14.5356C11.0989 14.5356 10.9 14.618 10.7533 14.7647C10.6066 14.9114 10.5242 15.1103 10.5242 15.3178ZM10.8066 15.8176C10.8066 15.8176 10.8066 15.8176 10.8066 15.8176V15.8176Z",
			fill: "#878A8F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.96752 0.266025L0.16605 4.06749C0.0600615 4.17348 0 4.31833 0 4.46848V15.3624C0 15.675 0.252607 15.9276 0.565274 15.9276H7.72541V14.6558H1.27187V5.92936H5.08747C5.28424 5.92936 5.47295 5.8512 5.61208 5.71206C5.75122 5.57292 5.82939 5.38421 5.82939 5.18744V1.37184H11.1642V5.75272H12.436V0.66525C12.436 0.352582 12.1834 0.0999756 11.8708 0.0999756H4.36674C4.21659 0.0999756 4.07351 0.160036 3.96752 0.266025ZM4.62818 4.72816H1.30366L4.62818 1.40364V4.72816Z",
			fill: "#878A8F"
		})
	]
});
export default SvgRfi;
